import React, { Component } from 'react'
import '../../css/BisharatMain.css';
import ImageDataService from '../../services/ImageDataService';
import AuthService from '../../services/AuthService';
import AlbumDataService from '../../services/AlbumDataService';

import Form from "react-validation/build/form";
import Input from "react-validation/build/input";
import CheckButton from "react-validation/build/button";

import Login from '../../pages/Login';
import { MdDelete } from "react-icons/md";
import { ImImages } from "react-icons/im";
import { MemberLinkBtnBordo } from '../../styles/Elements';
export default class AlbumManager extends Component {
    constructor() {
        super()
        this.state = {
            authorized: false,
            haveRoleOfAdminOrMod: false,
            albums: [],
            selectedAlbum: {},
            showAlbumClicked: false,
            imagesInsideAlbum: [],

            albumName: '',
            albumDescription: '',
            loadingAlbum: false,

            // albumOfImage: '',
            imageName: '',
            description: '',
        
            
            loadingImage: false,
            messageAlbum: "",
            // messageImage: ""
        };

        this.onChangeAlbumName = this.onChangeAlbumName.bind(this);
        this.onChangeAlbumDesc = this.onChangeAlbumDesc.bind(this);
        this.onSubmitNewAlbum = this.onSubmitNewAlbum.bind(this);

        this.onSubmitImage = this.onSubmitImage.bind(this);
        this.onChangeImage = this.onChangeImage.bind(this);
        this.onChangeSelectedOption = this.onChangeSelectedOption.bind(this);
    }


    componentDidMount() {
        this.refreshAlbums();
        this.setState({ selectedAlbum: '' });
    }


    refreshAlbums = () => {
        const loggedInUser = AuthService.getCurrentUser();
        const whatRole = AuthService.getUserRole();
        if (!loggedInUser || (whatRole === ('USER'))) { } else {
            this.setState({ authorized: true })
            if (whatRole === ('MODERATOR') || whatRole === ('ADMIN')) {
                this.setState({ haveRoleOfAdminOrMod: true });
            }
            AlbumDataService.getAllAlbums()
                .then(res => {
                    const albums = res.data;
                    this.setState({ albums });
                })
        }
    }


    showAlbumImgs(album) {
        this.setState({ selectedAlbum: album })
        this.setState({ showAlbumClicked: true })
        AlbumDataService.getAllAlbumImages(album.id)
            .then(res => {
                const imagesInsideAlbum = res.data;
                this.setState({ imagesInsideAlbum });
     
            })
    }




    deleteAlbumClicked(id) {
        AlbumDataService.deleteAlbum(id)
        .then(res => {
            alert("Album Deleted Successfully !");
            window.location.reload();
        },
        error => { 
             const resMessage =
            (error.response &&
              error.response.data &&
              error.response.data.message) ||
            error.message ||
            error.toString();
          alert(resMessage);
          window.location.reload();
        }
      );
    }





    deleteImgfronAlbumClicked(imgId) {

        ImageDataService.deletImage(imgId)
        .then(res => {
            alert("Image Deleted Successfully !");
            window.location.reload();
        },
        error => { 
             const resMessage =
            (error.response &&
              error.response.data &&
              error.response.data.message) ||
            error.message ||
            error.toString();
          alert(resMessage);
          window.location.reload();
        }
      );
    }


    onChangeImage(event) {
        this.setState({ [event.target.name]: event.target.value })
    }

    onChangeSelectedOption(event) {
        this.setState({ albumOfImage: event.target.value });
     
    }



    onSubmitImage(event) {
        event.preventDefault()

        this.setState({
            messageImage: "",
            loadingImage: true
        });

        this.form.validateAll();

        if (this.checkBtnImg.context._errors.length === 0) {
            this.fileUpalodHandler();
        } else {
            this.setState({
                loadingImage: false
            });
        }

    };



    fileSelectedHandler = event => {
        this.setState({
            selectedFile: event.target.files[0]
        })
    }

    fileUpalodHandler = () => {
        const fileData = new FormData();
        fileData.append('file', this.state.selectedFile)
        fileData.append('imageName', this.state.imageName);
        fileData.append('description', this.state.description);
        fileData.append('albumOfImage', this.state.albumOfImage);
        fileData.set('imageCeatedBy', AuthService.getCurrentUser().id);


        this.createImage(fileData);
     
    }

   

    createImage(data) {
        return ImageDataService.createImage(data)
        .then(res => {
            alert("Uploaded Successfully !");
            window.location.reload();
        },
        error => { 
             const resMessage =
            (error.response &&
              error.response.data &&
              error.response.data.message) ||
            error.message ||
            error.toString();

        //         this.setState({
        //     loading: false,
        //     messageImage: resMessage
        //   });
          alert(resMessage);
          window.location.reload();
        }
      );
    }
  



    //Album Create : 
    onChangeAlbumName(e) {
        this.setState({
            albumName: e.target.value
        });
    }


    onChangeAlbumDesc(e) {
        this.setState({
            albumDescription: e.target.value
        });
    }


    onSubmitNewAlbum(e) {
        e.preventDefault();

        this.setState({
            messageAlbum: "",
            loadingAlbum: true
        });

        this.formAlbum.validateAll();

        if (this.checkBtn.context._errors.length === 0) {
            const newAlbum = {
                name: this.state.albumName,
                description: this.state.albumDescription
            };
            this.createNewAlbum(newAlbum);
        } else {
            this.setState({
                loadingAlbum: false

            });
        }
    };






    createNewAlbum(data) {
        AlbumDataService.createAlbum(data)
            .then((response) => {
                this.setState({
                    messageAlbum: response.data.message,
                    successful: true
                });
                window.location.reload();
            },
                error => {
                    const resMessage =
                        (error.response &&
                            error.response.data &&
                            error.response.data.message) ||
                        error.message ||
                        error.toString();

                    this.setState({
                        successful: false,
                        messageAlbum: resMessage
                    });
                }
            );
    }




    render() {


        const required = value => {
            if (!value) {
                return (
                    <div className="alertDanger" >
                        <p className="alertDanger">
                            اجباري
                </p>
                    </div>
                );
            }
        };

        const notselectedalbum = value => {
            if( value === "notselectedalbum") {
                return (
                    <div className="alertDanger" >
                        <p className="alertDanger">
                            Please Select Album
                </p>
                    </div>
                );
            }
        };
        
        return (
            <div>
                {!this.state.authorized ?
                    <div>
                        <Login></Login>
                    </div> :
                    <div className="top-level-page-main-free-style gallery-control">
                        <div className="container-view-contents-free-style gallery-control">

                            <div className="albums-list">
                                <div className="top-actions gallery-control">
                                    <MemberLinkBtnBordo to='/adminboard/'> Back to Admin Board </MemberLinkBtnBordo>
                                    {/* <input
                                        type="text"
                                        className="search"
                                        name="searchfield"
                                        placeholder="Search Email"
                                        value={this.state.search}
                                        onChange={this.onchangeFind}
                                    /> */}

                                </div>


                                <table className="table-of-users">
                                    <tbody>
                                        <tr>
                                            <th className="head-table">ِAlbum Name</th>
                                            <th className="head-table">Description</th>
                                            <th className="head-table">Control Buttons</th>
                                        </tr>
                                        {this.state.albums.map(album => (
                                            <tr key={album.id}>
                                                <th>{album.name}</th>
                                                <th>{album.description}</th>
                                                <th>
                                                    <MdDelete
                                                        onClick={() => { if (window.confirm('Are you sure you want to delete this album?')) this.deleteAlbumClicked(album.id) }} size={20} color="red" />
                                                    <ImImages
                                                        onClick={() => this.showAlbumImgs(album)} size={20} color="red" />
                                                </th>
                                            </tr>
                                        ))}

                                    </tbody>
                                </table>
                            </div>



                            <div className="images-list">
                                {this.state.showAlbumClicked ?


                                    <table className="table-of-users">
                                        <tbody>
                                            <tr>
                                                <th className="head-table">ِImg Name</th>
                                                <th className="head-table">ِImg Desc</th>
                                                <th className="head-table">Img Contol</th>

                                            </tr>
                                            {this.state.imagesInsideAlbum.map(img => (

                                                <tr key={img.id}>
                                                    <th>{img.name}</th>
                                                    <th>{img.description}</th>
                                                    <th>
                                                        <MdDelete
                                                            onClick={() => { if (window.confirm('Are you sure you want to delete this image from Album?')) this.deleteImgfronAlbumClicked(img.id) }} size={20} color="red" />
                                                    </th>
                                                </tr>

                                            ))}
                                        </tbody></table>
                                    : <div></div>}
                            </div>






                            <div className="create-album">
                                <div className="profile-details">
                                    <Form
                                        onSubmit={this.onSubmitNewAlbum}
                                        ref={c => {
                                            this.formAlbum = c;
                                        }}>
                                        <div className="form-group-create">
                                            <h5> Album Name </h5>
                                            <Input

                                                type="text"
                                                name="albumName" placeholder="Album-Name"
                                                value={this.state.albumName}
                                                onChange={this.onChangeAlbumName}
                                                validations={[required]}
                                            />
                                        </div>
                                        <div className="form-group-create">
                                            <h5> Description  </h5>
                                            <Input

                                                type="text"
                                                name="albumDescription" placeholder="Description"
                                                value={this.state.albumDescription}
                                                onChange={this.onChangeAlbumDesc}
                                                validations={[required]}
                                            />
                                        </div>
                                        <div className="form-group-create">
                                            <button
                                                className="btn"
                                                disabled={this.state.loadingAlbum}
                                            >
                                                {this.state.loadingAlbum && (
                                                    <span className="spinner-border spinner-border-sm"></span>
                                                )}
                ارسال
              </button>
                                        </div>

                                        {/* <input type="submit" value="ارسال" className="btn btn-primary btn-block mt-4" /> */}

                                        {this.state.messageAlbum && (
                                            <div className="form-group">
                                                <div className="alertDanger" role="alert">
                                                    {this.state.messageAlbum}
                                                </div>
                                            </div>
                                        )}
                                        <CheckButton
                                            style={{ display: "none" }}
                                            ref={c => {
                                                this.checkBtn = c;
                                            }}
                                        />
                                    </Form>
                                </div>
                            </div>





                            <div className="img-create">

                                <div className="profile-details">
                                    <Form onSubmit={this.onSubmitImage}
                                        ref={img => {
                                            this.form = img;
                                        }}>
                                        <div className="form-group-create">
                                            <h5> Image Name </h5>
                                            <Input

                                                type="text"
                                                name="imageName" placeholder="Image-Name"
                                                value={this.state.imageName}
                                                onChange={this.onChangeImage}
                                                validations={[required]}
                                            />
                                        </div>
                                        <div className="form-group-create">
                                            <h5> Description  </h5>
                                            <Input

                                                type="text"
                                                name="description" placeholder="Description"
                                                value={this.state.description}
                                                onChange={this.onChangeImage}
                                                validations={[required]}
                                            />
                                        </div>


                                        <div className="form-group-create">
                                            <h5> Album </h5>
                                            <select
                                                value={this.state.albumOfImage}
                                                onChange={this.onChangeSelectedOption}
                                                validations={[notselectedalbum]}
                                            >
                                             
                                                {this.state.albums.map((album) => (                                            
                                                    <option  key={album.id} value={album.name}>{album.name}</option>
                                                ))}
                                               <option value=""></option>
                                            </select>
                                        </div>


                                        <div className="actionsProfile">
                                            <input type='file' onChange={this.fileSelectedHandler} />
                                            <button className="btn" disabled={this.state.loadingImage}>
                                              {this.state.loadingImage && (
                                                <span className="spinner-border spinner-border-sm"></span>
                                            )}
                                            Create Image
                                            </button>
                                           </div>  
                                            {/* {this.state.messageImage && (
                                                <div className="form-group">
                                                    <div className="alertDanger" role="alert">
                                                        {this.state.messageImage}
                                                    </div>
                                                </div>
                                            )} */}
                                       

                                        <CheckButton
                                            style={{ display: "none" }}
                                            ref={img => {
                                                this.checkBtnImg = img;
                                            }}
                                        />
                                    </Form>
                                </div>
                            </div>




                        </div>
                    </div>
                }



            </div>





        )
    }

}
